__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/2ab95b334fa5da9d589a199df3b6e2f13efc132d47fe973b7ce4ad5c/";